window.setting_recommend = {
  SkinConcerns: [
    "Acne-Prone Skin",
    "Blackheads, Whiteheads / Excess Sebum",
    "Blotchy or Red Skin Tone",
    "Body Skin Concerns",
    "Dark Spots, Pigmentation, Freckles",
    "Dead Skin, Rough Skin / Flaky Makeup",
    "Dehydrated / Very Dry / Tight Skin",
    "Eye Wrinkles, Eye Bags, Dark Circles",
    "Fine Lines & Wrinkles",
    "Overheated & Flushed Skin",
  ],
  Products: {
    "Acne-Prone SkinThe Others": [
      {
        subject: "Cleanser",
        USP: "Deep-cleansing gel with Houttuynia to unclog pores and remove embedded impurities.",
        ProductName: "Panthenol Heartleaf Calming Gel Cleanser",
        URLhandle: "parnell-panthenol-heartleaf-calming-gel-cleanser",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Cream",
        USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
        ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
        URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Instant soothing mask with panthenol and Houttuynia to calm irritated skin.",
        ProductName: "Panthenol Heartleaf Cool Calming Mask",
        URLhandle: null,
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Mist",
        USP: "Dual-layer mist with CicaMannu™ Biome to restore and soothe fatigued skin.",
        ProductName: "Cicamanu Serum Mist",
        URLhandle: "parnell-cicamanu-serum-mist",
        Combinations: [
          {
            ProductName: "Cicamanu 92 Serum",
            USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
            URLhandle: "parnell-cicamanu-92-serum",
          },
          {
            ProductName: "Cicamanu Gel Cream",
            USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
            URLhandle: "cicamanu-gel-cream",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "Cooling pads to rapidly reduce skin heat and calm irritation.",
        ProductName: "Panthenol Heartleaf Calming Pad",
        URLhandle: "panthenol-heartleaf-calming-pad",
        Combinations: [
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Acne Patch",
        USP: "Hydrocolloid spot patch in 3 sizes for precise soothing anywhere you need.",
        ProductName: "Cicamanu Clear Patch",
        URLhandle: "cicamanu-clear-patch",
        Combinations: [
          {
            ProductName: "Panthenol Heartleaf Calming Gel Cleanser",
            USP: "Deep-cleansing gel with Houttuynia to unclog pores and remove embedded impurities.",
            URLhandle: "parnell-panthenol-heartleaf-calming-gel-cleanser",
          },
          {
            ProductName: "Panthenol Heartleaf Calming Pad",
            USP: "Cooling pads to rapidly reduce skin heat and calm irritation.",
            URLhandle: "panthenol-heartleaf-calming-pad",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
        ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
        URLhandle: "panthenol-5-78-heartleaf-calming-serum",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
        ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
        URLhandle: "panthenol-3-28-heartleaf-calming-toner",
        Combinations: [
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay wash-off pack that visibly brightens and refines dull skin.",
        ProductName: "Niacinamide Rice Brightening Wash-Off Pack",
        URLhandle: "niacinamide-rice-brightening-wash-off-pack",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Rapid soothing and cooling care for troubled skin.",
        ProductName: "Panthenol Full Set",
        URLhandle: "panthenol-full-set",
        Combinations: [],
      },
    ],
    "Acne-Prone SkinSensitive": [
      {
        subject: "Cream",
        USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
        ProductName: "Cicamanu Gel Cream",
        URLhandle: "cicamanu-gel-cream",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Cicamanu 92 Serum",
            USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
            URLhandle: "parnell-cicamanu-92-serum",
          },
        ],
      },
      {
        subject: "Mist",
        USP: "Dual-layer mist with CicaMannu™ Biome to restore and soothe fatigued skin.",
        ProductName: "Cicamanu Serum Mist",
        URLhandle: "parnell-cicamanu-serum-mist",
        Combinations: [
          {
            ProductName: "Cicamanu 92 Serum",
            USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
            URLhandle: "parnell-cicamanu-92-serum",
          },
          {
            ProductName: "Cicamanu Gel Cream",
            USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
            URLhandle: "cicamanu-gel-cream",
          },
        ],
      },
      {
        subject: "Acne Patch",
        USP: "Hydrocolloid spot patch in 3 sizes for precise soothing anywhere you need.",
        ProductName: "Cicamanu Clear Patch",
        URLhandle: "cicamanu-clear-patch",
        Combinations: [
          {
            ProductName: "Panthenol Heartleaf Calming Gel Cleanser",
            USP: "Deep-cleansing gel with Houttuynia to unclog pores and remove embedded impurities.",
            URLhandle: "parnell-panthenol-heartleaf-calming-gel-cleanser",
          },
          {
            ProductName: "Panthenol Heartleaf Calming Pad",
            USP: "Cooling pads to rapidly reduce skin heat and calm irritation.",
            URLhandle: "panthenol-heartleaf-calming-pad",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
        ProductName: "Cicamanu 92 Serum",
        URLhandle: "parnell-cicamanu-92-serum",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Cicamanu Gel Cream",
            USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
            URLhandle: "cicamanu-gel-cream",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay wash-off pack that visibly brightens and refines dull skin.",
        ProductName: "Niacinamide Rice Brightening Wash-Off Pack",
        URLhandle: "niacinamide-rice-brightening-wash-off-pack",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Intensive calming solution for sensitive skin.",
        ProductName: "Cicamanu Full Set",
        URLhandle: "cicamanu-skincare-full-set",
        Combinations: [],
      },
    ],
    "Blackheads, Whiteheads / Excess Sebum": [
      {
        subject: "Cleansing Oil",
        USP: "Gentle cleansing oil that melts away deep pore buildup.",
        ProductName: "AHA Omija Ceramic Cleansing Oil",
        URLhandle: "aha-omija-ceramic-cleansing-oil",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
            USP: "Gommage foam cleanser for cleansing and peeling in one step.",
            URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
          },
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
        ProductName: "AHA Omija Ceramic Pad",
        URLhandle: "aha-omija-ceramic-pad",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Cream Clay Pack",
            USP: "Clay pack that absorbs rough dead skin while locking in moisture.",
            URLhandle: "aha-omija-ceramic-cream-clay-pack",
          },
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
        ],
      },
      {
        subject: "Cleanser",
        USP: "Gommage foam cleanser for cleansing and peeling in one step.",
        ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
        URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay pack that absorbs rough dead skin while locking in moisture.",
        ProductName: "AHA Omija Ceramic Cream Clay Pack",
        URLhandle: "aha-omija-ceramic-cream-clay-pack",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
        ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
        URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Cleansing Oil",
            USP: "Gentle cleansing oil that melts away deep pore buildup.",
            URLhandle: "aha-omija-ceramic-cleansing-oil",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Smooths skin texture and exfoliates gently.",
        ProductName: "AHA Full Set",
        URLhandle: "aha-omija-full-set",
        Combinations: [],
      },
    ],
    "Blotchy or Red Skin Tone": [
      {
        subject: "Cleanser",
        USP: "Gommage foam cleanser for cleansing and peeling in one step.",
        ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
        URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Cream",
        USP: "Pore-tightening cream with 7-in-1 care for refined, firm skin.",
        ProductName: "Bakuchiol Retionol Wild Yam Firming Cream",
        URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-cream",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam Cream Coating Mask",
            USP: "Lifting mask pack to visibly firm and sculpt loose skin.",
            URLhandle:
              "bakuchiol-retinol-wild-yam-firming-cream-coating-mask-5ea",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
            USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam Firming Eye Patch",
            USP: "Firming eye patch that lifts and tightens sagging under-eyes.",
            URLhandle: "bakuchiol-retinol-wild-yam-firming-eye-patch",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Brightening mask that evens out blotchy skin tone.",
        ProductName: "Niacinamide Rice Brightening Gel Mask",
        URLhandle: "niacinamide-rice-brightening-gel-mask",
        Combinations: [
          {
            ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
            USP: "Milky toner for both hydration and tone correction.",
            URLhandle: "niacinamide-4-12-rice-ampoule-toner",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "DIY waffle pads that stretch to fit and refine uneven skin texture.",
        ProductName: "Niacinamide Rice Brightening Pad",
        URLhandle: "parnell-niacinamide-1-56-rice-brightening-pad",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Brightening serum that targets dullness and hidden spots.",
        ProductName: "Niacinamide 20.35 Rice Brightening Serum",
        URLhandle: "niacinamide-20-35-rice-brightening-serum",
        Combinations: [
          {
            ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
            USP: "Milky toner for both hydration and tone correction.",
            URLhandle: "niacinamide-4-12-rice-ampoule-toner",
          },
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Milky toner for both hydration and tone correction.",
        ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
        URLhandle: "niacinamide-4-12-rice-ampoule-toner",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay wash-off pack that visibly brightens and refines dull skin.",
        ProductName: "Niacinamide Rice Brightening Wash-Off Pack",
        URLhandle: "niacinamide-rice-brightening-wash-off-pack",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Brightens and evens out skin tone.",
        ProductName: "Niacinamide Full Set",
        URLhandle: "niacinamid-full-set",
        Combinations: [],
      },
    ],
    "Body Skin Concerns": [
      {
        subject: "Body Mist",
        USP: "Body mist with CicaMannu™ Biome to soothe irritated skin gently.",
        ProductName: "Cicamanu pH Balanced Body Mist",
        URLhandle: "parnell-cicamanu-ph-balanced-body-mist",
        Combinations: [
          {
            ProductName: "Cicamanu pH Balanced Body Wash",
            USP: "Body wash with CicaMannu™ Biome for calming sensitive skin.",
            URLhandle: "body-wash",
          },
        ],
      },
      {
        subject: "Body Wash",
        USP: "Body wash with CicaMannu™ Biome for calming sensitive skin.",
        ProductName: "Cicamanu pH Balanced Body Wash",
        URLhandle: "body-wash",
        Combinations: [
          {
            ProductName: "Cicamanu pH Balanced Body Mist",
            USP: "Body mist with CicaMannu™ Biome to soothe irritated skin gently.",
            URLhandle: "parnell-cicamanu-ph-balanced-body-mist",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "oothing and moisturizing care for dry, breakout-prone body skin.",
        ProductName: "Cicamanu Body Full Set",
        URLhandle: "body-clear-set",
        Combinations: [],
      },
    ],
    "Dark Spots, Pigmentation, Freckles": [
      {
        subject: "Cleanser",
        USP: "Gommage foam cleanser for cleansing and peeling in one step.",
        ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
        URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Brightening mask that evens out blotchy skin tone.",
        ProductName: "Niacinamide Rice Brightening Gel Mask",
        URLhandle: "niacinamide-rice-brightening-gel-mask",
        Combinations: [
          {
            ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
            USP: "Milky toner for both hydration and tone correction.",
            URLhandle: "niacinamide-4-12-rice-ampoule-toner",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "DIY waffle pads that stretch to fit and refine uneven skin texture.",
        ProductName: "Niacinamide Rice Brightening Pad",
        URLhandle: "parnell-niacinamide-1-56-rice-brightening-pad",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Brightening serum that targets dullness and hidden spots.",
        ProductName: "Niacinamide 20.35 Rice Brightening Serum",
        URLhandle: "niacinamide-20-35-rice-brightening-serum",
        Combinations: [
          {
            ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
            USP: "Milky toner for both hydration and tone correction.",
            URLhandle: "niacinamide-4-12-rice-ampoule-toner",
          },
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Milky toner for both hydration and tone correction.",
        ProductName: "Niacinamide 4.12 Rice Brightening Ampoule Toner",
        URLhandle: "niacinamide-4-12-rice-ampoule-toner",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay wash-off pack that visibly brightens and refines dull skin.",
        ProductName: "Niacinamide Rice Brightening Wash-Off Pack",
        URLhandle: "niacinamide-rice-brightening-wash-off-pack",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Brightens and evens out skin tone.",
        ProductName: "Niacinamide Full Set",
        URLhandle: "niacinamid-full-set",
        Combinations: [],
      },
    ],
    "Dead Skin, Rough Skin / Flaky Makeup": [
      {
        subject: "Cleansing Oil",
        USP: "Gentle cleansing oil that melts away deep pore buildup.",
        ProductName: "AHA Omija Ceramic Cleansing Oil",
        URLhandle: "aha-omija-ceramic-cleansing-oil",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
            USP: "Gommage foam cleanser for cleansing and peeling in one step.",
            URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
          },
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
        ],
      },
      {
        subject: "Cream",
        USP: "Pore-tightening cream with 7-in-1 care for refined, firm skin.",
        ProductName: "Bakuchiol Retionol Wild Yam Firming Cream",
        URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-cream",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam Cream Coating Mask",
            USP: "Lifting mask pack to visibly firm and sculpt loose skin.",
            URLhandle:
              "bakuchiol-retinol-wild-yam-firming-cream-coating-mask-5ea",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
            USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam Firming Eye Patch",
            USP: "Firming eye patch that lifts and tightens sagging under-eyes.",
            URLhandle: "bakuchiol-retinol-wild-yam-firming-eye-patch",
          },
        ],
      },
      {
        subject: "Mist",
        USP: "Dual-layer mist with CicaMannu™ Biome to restore and soothe fatigued skin.",
        ProductName: "Cicamanu Serum Mist",
        URLhandle: "parnell-cicamanu-serum-mist",
        Combinations: [
          {
            ProductName: "Cicamanu 92 Serum",
            USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
            URLhandle: "parnell-cicamanu-92-serum",
          },
          {
            ProductName: "Cicamanu Gel Cream",
            USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
            URLhandle: "cicamanu-gel-cream",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
        ProductName: "AHA Omija Ceramic Pad",
        URLhandle: "aha-omija-ceramic-pad",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Cream Clay Pack",
            USP: "Clay pack that absorbs rough dead skin while locking in moisture.",
            URLhandle: "aha-omija-ceramic-cream-clay-pack",
          },
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
        ],
      },
      {
        subject: "Cleanser",
        USP: "Gommage foam cleanser for cleansing and peeling in one step.",
        ProductName: "AHA Omija Ceramic Bubble Peeling Cleanser",
        URLhandle: "aha-omija-ceramic-bubble-peeling-cleanser",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Clay pack that absorbs rough dead skin while locking in moisture.",
        ProductName: "Squalane Mineral Water Moisture Capsule Toner",
        URLhandle: "squalane-mineral-water-moisture-capsule-toner",
        Combinations: [
          {
            ProductName: "Squalane Mineral Water Moisture Capsule Toner",
            USP: "Slush toner with triple-layer hydration to quench dehydrated skin.",
            URLhandle: "squalane-mineral-water-moisture-capsule-toner",
          },
          {
            ProductName: "Squalane 20.04 Mineral Water Moisture Serum",
            USP: "Hydrating serum with Chojeong mineral water for multi-layer moisture.",
            URLhandle: "squalane-20-04-mineral-water-moisture-serum",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
        ProductName: "AHA Omija Ceramic Cream Clay Pack",
        URLhandle: "aha-omija-ceramic-cream-clay-pack",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Gommage foam cleanser for cleansing and peeling in one step.",
        ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
        URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
        Combinations: [
          {
            ProductName: "AHA Omija Ceramic Cleansing Oil",
            USP: "Gentle cleansing oil that melts away deep pore buildup.",
            URLhandle: "aha-omija-ceramic-cleansing-oil",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Smooths skin texture and exfoliates gently.",
        ProductName: "AHA Full Set",
        URLhandle: "aha-omija-full-set",
        Combinations: [],
      },
    ],
    "Dehydrated / Very Dry / Tight Skin": [
      {
        subject: "Cleanser",
        USP: "Deep-cleansing gel with Houttuynia to unclog pores and remove embedded impurities.",
        ProductName: "Panthenol Heartleaf Calming Gel Cleanser",
        URLhandle: "parnell-panthenol-heartleaf-calming-gel-cleanser",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Cream",
        USP: "Ultra-moisture cream that locks in hydration from deep within.",
        ProductName: "Squalane 15.13 Mineral Water Moisture Cream",
        URLhandle: "squalane-15-13-mineral-water-moisture-cream",
        Combinations: [
          {
            ProductName: "Squalane Mineral Water Moisture Capsule Toner",
            USP: "Slush toner with triple-layer hydration to quench dehydrated skin.",
            URLhandle: "squalane-mineral-water-moisture-capsule-toner",
          },
          {
            ProductName: "Squalane 20.04 Mineral Water Moisture Serum",
            USP: "Hydrating serum with Chojeong mineral water for multi-layer moisture.",
            URLhandle: "squalane-20-04-mineral-water-moisture-serum",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Instant soothing mask with panthenol and Houttuynia to calm irritated skin.",
        ProductName: "Panthenol Heartleaf Cool Calming Mask",
        URLhandle: null,
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Mist",
        USP: "Dual-layer mist with CicaMannu™ Biome to restore and soothe fatigued skin.",
        ProductName: "Cicamanu Serum Mist",
        URLhandle: "parnell-cicamanu-serum-mist",
        Combinations: [
          {
            ProductName: "Cicamanu 92 Serum",
            USP: "Fast-acting serum with CicaMannu™ Biome to calm sensitized skin in 2 weeks.",
            URLhandle: "parnell-cicamanu-92-serum",
          },
          {
            ProductName: "Cicamanu Gel Cream",
            USP: "Hydrating cream with CicaMannu™ Biome and Aquaxyl for dry, sensitive skin.",
            URLhandle: "cicamanu-gel-cream",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "Cooling pads to rapidly reduce skin heat and calm irritation.",
        ProductName: "Panthenol Heartleaf Calming Pad",
        URLhandle: "panthenol-heartleaf-calming-pad",
        Combinations: [
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Hydrating serum with Chojeong mineral water for multi-layer moisture.",
        ProductName: "Squalane 20.04 Mineral Water Moisture Serum",
        URLhandle: "squalane-20-04-mineral-water-moisture-serum",
        Combinations: [
          {
            ProductName: "Squalane Mineral Water Moisture Capsule Toner",
            USP: "Slush toner with triple-layer hydration to quench dehydrated skin.",
            URLhandle: "squalane-mineral-water-moisture-capsule-toner",
          },
          {
            ProductName: "Squalane 15.13 Mineral Water Moisture Cream",
            USP: "Ultra-moisture cream that locks in hydration from deep within.",
            URLhandle: "squalane-15-13-mineral-water-moisture-cream",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Slush toner with triple-layer hydration to quench dehydrated skin.",
        ProductName: "Squalane Mineral Water Moisture Capsule Toner",
        URLhandle: "squalane-mineral-water-moisture-capsule-toner",
        Combinations: [
          {
            ProductName: "Squalane 20.04 Mineral Water Moisture Serum",
            USP: "Hydrating serum with Chojeong mineral water for multi-layer moisture.",
            URLhandle: "squalane-20-04-mineral-water-moisture-serum",
          },
          {
            ProductName: "Squalane 15.13 Mineral Water Moisture Cream",
            USP: "Ultra-moisture cream that locks in hydration from deep within.",
            URLhandle: "squalane-15-13-mineral-water-moisture-cream",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay wash-off pack that visibly brightens and refines dull skin.",
        ProductName: "Niacinamide Rice Brightening Wash-Off Pack",
        URLhandle: "niacinamide-rice-brightening-wash-off-pack",
        Combinations: [
          {
            ProductName: "Niacinamide Rice Brightening Gel Mask",
            USP: "Brightening mask that evens out blotchy skin tone.",
            URLhandle: "niacinamide-rice-brightening-gel-mask",
          },
          {
            ProductName: "Niacinamide 20.35 Rice Brightening Serum",
            USP: "Brightening serum that targets dullness and hidden spots.",
            URLhandle: "niacinamide-20-35-rice-brightening-serum",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Deep hydration for severely dry skin.",
        ProductName: "Squalane Full Set",
        URLhandle: "squalane-full-set",
        Combinations: [],
      },
    ],
    "Eye Wrinkles, Eye Bags, Dark Circles": [
      {
        subject: "Eye Patch",
        USP: "Firming eye patch that lifts and tightens sagging under-eyes.",
        ProductName: "Bakuchiol Retinol Wild Yam Firming Eye Patch",
        URLhandle: "bakuchiol-retinol-wild-yam-firming-eye-patch",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
            USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
          },
          {
            ProductName: "Bakuchiol Retionol Wild Yam Firming Cream",
            USP: "Pore-tightening cream with 7-in-1 care for refined, firm skin.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-cream",
          },
        ],
      },
    ],
    "Fine Lines & Wrinkles": [
      {
        subject: "Cream",
        USP: "Pore-tightening cream with 7-in-1 care for refined, firm skin.",
        ProductName: "Bakuchiol Retionol Wild Yam Firming Cream",
        URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-cream",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam Cream Coating Mask",
            USP: "Lifting mask pack to visibly firm and sculpt loose skin.",
            URLhandle:
              "bakuchiol-retinol-wild-yam-firming-cream-coating-mask-5ea",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
            USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam Firming Eye Patch",
            USP: "Firming eye patch that lifts and tightens sagging under-eyes.",
            URLhandle: "bakuchiol-retinol-wild-yam-firming-eye-patch",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Lifting mask pack to visibly firm and sculpt loose skin.",
        ProductName: "Bakuchiol Retinol Wild Yam Cream Coating Mask",
        URLhandle: "bakuchiol-retinol-wild-yam-firming-cream-coating-mask-5ea",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
            USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "7-in-1 pore serum with Bakuchiol and Retinol to tighten enlarged pores.",
        ProductName: "Bakuchiol Retinol Wild Yam 2.12 Firming Serum",
        URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-serum",
        Combinations: [
          {
            ProductName: "Bakuchiol Retinol Wild Yam Cream Coating Mask",
            USP: "Lifting mask pack to visibly firm and sculpt loose skin.",
            URLhandle:
              "bakuchiol-retinol-wild-yam-firming-cream-coating-mask-5ea",
          },
          {
            ProductName: "Bakuchiol Retionol Wild Yam Firming Cream",
            USP: "Pore-tightening cream with 7-in-1 care for refined, firm skin.",
            URLhandle: "bakuchiol-retinol-wild-yam-2-12-firming-cream",
          },
          {
            ProductName: "Bakuchiol Retinol Wild Yam Firming Eye Patch",
            USP: "Firming eye patch that lifts and tightens sagging under-eyes.",
            URLhandle: "bakuchiol-retinol-wild-yam-firming-eye-patch",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Pore-tightening and anti-aging care for firmer skin.",
        ProductName: "Bakuchiol Full Set",
        URLhandle: "bakuchiol-full-set",
        Combinations: [],
      },
    ],
    "Overheated & Flushed Skin": [
      {
        subject: "Cleanser",
        USP: "Deep-cleansing gel with Houttuynia to unclog pores and remove embedded impurities.",
        ProductName: "Panthenol Heartleaf Calming Gel Cleanser",
        URLhandle: "parnell-panthenol-heartleaf-calming-gel-cleanser",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Cream",
        USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
        ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
        URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
        ],
      },
      {
        subject: "Sheet Mask",
        USP: "Instant soothing mask with panthenol and Houttuynia to calm irritated skin.",
        ProductName: "Panthenol Heartleaf Cool Calming Mask",
        URLhandle: null,
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Pads",
        USP: "Cooling pads to rapidly reduce skin heat and calm irritation.",
        ProductName: "Panthenol Heartleaf Calming Pad",
        URLhandle: "panthenol-heartleaf-calming-pad",
        Combinations: [
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Serum",
        USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
        ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
        URLhandle: "panthenol-5-78-heartleaf-calming-serum",
        Combinations: [
          {
            ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
            USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
            URLhandle: "panthenol-3-28-heartleaf-calming-toner",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Toner",
        USP: "Soothing boosting toner to calm and comfort sensitive, stressed skin.",
        ProductName: "Panthenol 3.29 Heartleaf Calming Toner",
        URLhandle: "panthenol-3-28-heartleaf-calming-toner",
        Combinations: [
          {
            ProductName: "Panthenol 5.78 Heartleaf Calming Serum",
            USP: "Lightweight serum with panthenol and Houttuynia for fast blemish relief.",
            URLhandle: "panthenol-5-78-heartleaf-calming-serum",
          },
          {
            ProductName: "Panthenol 3.89 Heartleaf Calming Cream",
            USP: "Barrier cream with panthenol capsules for intensive soothing and hydration.",
            URLhandle: "panthenol-3-89-heartleaf-calming-capsule-cream",
          },
        ],
      },
      {
        subject: "Mask Pack",
        USP: "Clay pack that absorbs rough dead skin while locking in moisture.",
        ProductName: "AHA Omija Ceramic Cream Clay Pack",
        URLhandle: "aha-omija-ceramic-cream-clay-pack",
        Combinations: [
          {
            ProductName: "AHA 9.12 Omija Ceramic Wash-Off Serum",
            USP: "Wash-off serum that removes blackheads and dead skin in 1 minute.",
            URLhandle: "aha-9-12-omija-ceramic-wash-off-serum",
          },
          {
            ProductName: "AHA Omija Ceramic Pad",
            USP: "AHA + Schisandra peeling pads to smooth and exfoliate rough skin.",
            URLhandle: "aha-omija-ceramic-pad",
          },
        ],
      },
      {
        subject: "Not Sure",
        USP: "Rapid soothing and cooling care for troubled skin.",
        ProductName: "Panthenol Full Set",
        URLhandle: "panthenol-full-set",
        Combinations: [],
      },
    ],
  },
};
